import React, { useMemo } from 'react'
import { Portal } from '@gorhom/portal'
import { useToastManager } from './useToastManager'
import FullWindowOverlay from '@ui/compat/FullWindowOverlay/FullWindowOverlay'
import Animated, {
  LinearTransition,
  SlideInDown,
  useAnimatedStyle,
} from 'react-native-reanimated'
import { useReanimatedKeyboardAnimation } from 'react-native-keyboard-controller'
import { useWindowDimensions } from 'react-native'
import { ToastContainer } from './ToastContainer'
import { useMaxWindowDimensions } from '@ui/theme/useRWD'

const TOASTS_HOST = 'toasts'

const Toasts = () => {
  const toastsState = useToastManager((s) => s.toasts)
  const toasts = useMemo(() => [...toastsState], [toastsState])
  const { height: keyboardHeight } = useReanimatedKeyboardAnimation()
  const { width, height } = useMaxWindowDimensions()
  const dimensions = useWindowDimensions()
  const left = dimensions.width / 2 - width / 2

  const containerStyle = useAnimatedStyle(() => {
    return {
      paddingBottom: Math.abs(keyboardHeight.value),
    }
  })

  return (
    <Portal hostName={TOASTS_HOST}>
      <FullWindowOverlay>
        <Animated.View
          style={[
            {
              pointerEvents: 'box-none',
            },
            { width, left, height },
            containerStyle,
          ]}
          className="pointer-events-none absolute bottom-8 items-center justify-end gap-4 p-8"
        >
          {toasts.map(([id, toast]) => (
            <Animated.View
              entering={SlideInDown}
              layout={LinearTransition}
              key={id}
              className="pointer-events-auto w-full"
            >
              <ToastContainer key={id} {...toast} />
            </Animated.View>
          ))}
        </Animated.View>
      </FullWindowOverlay>
    </Portal>
  )
}

Toasts.TOASTS_HOST = TOASTS_HOST

export default Toasts
